import MD5 from "crypto-js/md5";
import Cookies from "js-cookie";
import store from "@/store";

const generateRandomString = (length: number) => {
	const characters =
		"abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
	let result = "";
	const charactersLength = characters.length;
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
};

export const getHeaders = () => {
	const _serviceId = "h5";
	const _version = "1.0.0";
	const _appType = "h5";
	const salt = "1HL29kB2Jjz4lsxrgSk8c12B";
	const token =
		Cookies.get("hdl_token") || sessionStorage.getItem("token") || "";
	const common = store.getState().common;
	const _country = common.country || "";
	const secretCode = generateRandomString(6);
	const timestamp = Date.now();

	const rawSign =
		_serviceId +
		_version +
		_appType +
		_country +
		secretCode +
		timestamp.toString() +
		salt;
	const md5First = MD5(rawSign).toString();
	const md5Second = MD5(md5First).toString();
	const sign = md5Second.split("").reverse().join("").toLowerCase();

	return {
		sign,
		timestamp,
		serviceId: _serviceId,
		version: _version,
		appType: _appType,
		country: _country,
		language: "cn",
		secretCode,
		_haidilao_app_token: token,
	};
};
